import { mapGetters } from "vuex";
import moment from "moment-timezone";

export default {

  orderToPost: {
    methods: {
      orderToPost(orderState) {
        let o = orderState;

        let orderLines = [];
        for (var i in o.solution.baseProducts) {
          orderLines.push({
            "id": o.solution.baseProducts[i].id,
            "price": o.solution.baseProducts[i].price,
            "quantity": 1,
          });
        }

        for (var i in o.addonProducts) {
          if (o.addonProducts[i].hasOwnProperty("id")) {
            orderLines.push({
              "id": o.addonProducts[i].id,
              //     "price": o.solution.addonProducts[i].price,
              "quantity": 1,
            });
          }
        }

        return {
          "customerFullName": o.customer.fullName,
          "customerEmail": o.customer.email,
          "customerAddressLine1": o.customer.addressLine1,
          "customerPostcode": o.customer.postCode,
          "customerPlace": o.customer.place,
          "customerPhone": o.customer.phone,
          "orderLines": orderLines,
          "retailerOrderRef": o.retailerOrderRef,
          "orderNotes": o.orderNotes,
          "approvedByHouseOwner": o.customer.approvedByHouseOwner,
          "customerCarDeliveryDate": moment(o.customer.carDeliveryDate).add(12, "hours"),
          "customerCarBrand": o.customer.carBrand.label,
          "customerCarModel": o.customer.carModel.name,

          // "customerCarBrand": o.user.customerPostcode,

        }

      },
    }
  },


  addonCardTransformer: {
    methods: {
      addonCardTransform(raw) {
        return {
          id: raw.id,
          title: raw.name,
          price: raw.price != 0 ? raw.price : "",
          imageUrl: raw.imageUrl
        }
      },
    }
  },

  solutionCardTransformer: {
    computed: {
      ...mapGetters([
          "getField"
        ]
      )
    },

    methods: {
      solutionCardTransform(raw, car) {

        let transform = {
          name: raw.baseName,
          effect: raw.effect,
          connectorCount: raw.connectorCount,
          connectorEffects: this.connectorEffects(raw),
          connectorType: this.connectorType(raw),
          imageUrl: raw.imageUrl,
          chargingTime: this.solutionChargingTime(raw, car),
          price: raw.basePrice,
          needCapacityAssessment: raw.needCapacityAssessment,
          deliveryFromDate: raw.deliveryFromDate,
          details: []
        };

        if (raw.deliveryFromDate != null && moment(raw.deliveryFromDate.date) > moment()) {
          transform.details.push({
            heading: this.$t("solutionCard.details.deliveryTime.heading", { month: moment(raw.deliveryFromDate.date).format("MMMM YYYY") }),
            label: this.$t("solutionCard.details.deliveryTime.label", { month: moment(raw.deliveryFromDate.date).format("MMMM YYYY") }),
            items: [],
            annotations: [
              this.$t("solutionCard.details.deliveryTime.description", { month: moment(raw.deliveryFromDate.date).format("MMMM YYYY") })
            ]
          })
        }

        if (raw.needCapacityAssessment) {
          transform.details.push({
            heading: this.$t("solutionCard.details.capacityCheckRequired.heading"),
            label: this.$t("solutionCard.details.capacityCheckRequired.label"),
            items: [],
            annotations: [
              this.$t("solutionCard.details.capacityCheckRequired.description"),
            ]
          })
        }

        transform.details.push({
          heading: this.$t("solutionCard.details.included.heading"),
          label: this.$t("solutionCard.details.included.label"),
          items: raw.servicesIncluded,
          annotations: [
            this.$t("solutionCard.details.included.description"),
          ]
        });

        return transform;
      },


      connectorEffects(raw) {
        let connectorEffects = {};
        for (let i = 1; i <= raw.connectorCount; i++) {
          connectorEffects[i] = (raw.effect) / i;
        }
        return connectorEffects;
      },
      connectorType(raw) {

        let connectorType = raw.connectorType;
        let connectorCount = raw.connectorCount;
        let integratedCable = raw.integratedCable;

        let type = connectorType ? connectorType.replace(/^\w/, c => c.toUpperCase()) : "";
        var integrated = (integratedCable === true) ? "fast kabel" : "uttak";
        return type + " " + integrated;
      },

      solutionChargingTime(raw, car) {
        // let effectSignature =  solution.current + "A" + solution.phase + "P"
        // todo: car as parameter to make function pure
        let connectorEffects = this.connectorEffects(raw)
        let range = [];


        for (let c in connectorEffects) {
          let effect = Math.min(car.maxEffect, connectorEffects[c]);
          let humanizedHour = this.humanizeNumber(Math.ceil(car.batteryCapacity / effect))
          if (!range.includes(humanizedHour)) {
            range.push(this.humanizeNumber(Math.ceil(car.batteryCapacity / effect)));
          }
        }

        if (range.length === 1) {
          return this.$tc("solutionCard.details.chargingSpeed", range[0], { model: car.name, hours: range[0] });
        } else {
          return this.$tc("solutionCard.details.chargingSpeedRange", range[1], {
            model: car.name,
            hoursMin: range[0],
            hoursMax: range[1]
          });
        }


      },

      humanizeNumber(number) {
        let numberWords = {
          1: this.$t('numbers.one'),
          2: this.$t('numbers.two'),
          3: this.$t('numbers.three'),
          4: this.$t('numbers.four'),
          5: this.$t('numbers.five'),
          6: this.$t('numbers.six'),
          7: this.$t('numbers.seven'),
          8: this.$t('numbers.eight'),
          9: this.$t('numbers.nine'),
          10: this.$t('numbers.ten'),
          11: this.$t('numbers.eleven'),
          12: this.$t('numbers.twelve'),
        }
        return numberWords.hasOwnProperty(number) ? numberWords[number] : number;


      }


    }
  }
}